import { useState } from "react"

import "../../styles/Modal.css"

import StockoutForm from "../forms/StockoutForm"
import StockinForm from "../forms/StockinForm"

function StockModal({ onClose }) {
  const [ stockoutList, setStockoutList ] = useState([])
  const [ stockinList, setStockinList ] = useState([])

  return (
    <div className="m-overlay" >

      <div className="sm-content" >
        <div className="m-header" >
          <h4 className="m-title">Stock Dashboard</h4>
          <button className="m-cancel-button-x" onClick={onClose}>X</button>
        </div>

        <div className="sm-body" >
          <StockoutForm stockoutList={stockoutList} setStockoutList={setStockoutList} stockinList={stockinList} />
          <StockinForm stockinList={stockinList} setStockinList={setStockinList} stockoutList={stockoutList} />
        </div>

        <div className="sm-footer" >
          <button className="m-cancel-button" onClick={onClose}>Close</button>
        </div>
      </div>

    </div>
  )
}

export default StockModal
